﻿import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { agricolaName, formatMilesDecimalNew, hasPermission } from "@/services/Utils";

import { ReactComponent as PencilSvg } from "@/assets/images/desktop/editar.svg";
import { ReactComponent as RemoveSvg } from "@/assets/images/desktop/remove.svg";
import { ReactComponent as ArchiveSvg } from "@/assets/images/desktop/archive.svg";
import { ReactComponent as ArchiveUpSvg } from "@/assets/images/desktop/archive-up.svg";
import { ReactComponent as ArrowUpSvg } from "@/assets/images/desktop/Flechaverdehorizontal.svg";
import { ReactComponent as ArrowDownSvg } from "@/assets/images/desktop/flechaverdeabajo.svg";

import { BUSINESS_CENTER_SHOW } from "@/redux/types/maintainers/business_center.type";

import TableMultiple from "@/components/Table/Multiple/TableMultiple";

import BusinessCenterTableDetail from "./BusinessCenterTableDetail";

import classes from "../../maintainers.module.scss";

const BusinessCenterTableBody = ({ filter, handleDelete, handleArchive, permissions, useSectors, handleShow }) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [totalArea, setTotalArea] = useState({});

	const { business_center } = useSelector((state) => state.maintainers_business_center);
	const { customer } = useSelector((state) => state.auth.user);

	const calculateTotalArea = () => {
		const areaSums = {};
		business_center.forEach((item) => {
			const filteredCenters = item.business_centers || [];
			const areaSum = filteredCenters.reduce((sum, businessCenter) => sum + (businessCenter.area || 0), 0);
			areaSums[item.id] = areaSum;
		});
		setTotalArea(areaSums);
	};

	useEffect(() => {
		if (business_center) {
			calculateTotalArea();
		}
		// eslint-disable-next-line
	}, [business_center]);

	const toggleShowDetail = (id) => {
		const newBusinessCenter = business_center.map((item) => {
			if (item.id === id) {
				item.show = !item.show;
			}
			return item;
		});
		dispatch({ type: BUSINESS_CENTER_SHOW, payload: { business_center: newBusinessCenter } });
	};

	return (
		<tbody>
			{business_center &&
				business_center.map((item, i) => {
					return [
						<tr key={i} className={`${classes.table_tr}`}>
							<td className={`${classes.table_td} ${classes.first_td}`}>
								<div className={`${classes.table_div}  ${classes.first_div}`}>{i + 1}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.long_text}`}>{item.name}</div>
							</td>
							{!!customer.use_estates_parents && (
								<td className={`${classes.table_td}`}>
									<div className={`${classes.table_div} ${classes.long_text} ${classes.center}`}>
										{agricolaName(item && item.estate_parent ? item.estate_parent.label : item.estate_parent_name)}
									</div>
								</td>
							)}
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.long_text} ${classes.center} ${classes.multiple}`}>
									<TableMultiple
										textItems={item.estates.map((estate) => estate.label).join(",")}
										showFunction={handleShow}
										showTitle={
											customer.customer_screens.find((cs) => cs.screen_id === 51)
												? customer.customer_screens.find((cs) => cs.screen_id === 51)?.name
												: "Campos"
										}
									/>
								</div>
							</td>
							{!!useSectors && (
								<td className={`${classes.table_td}`}>
									<div className={`${classes.table_div} ${classes.long_text} ${classes.center}`}>{`${formatMilesDecimalNew(
										String(totalArea[item.id]).replace(".", ","),
									)} Ha`}</div>
								</td>
							)}
							{!useSectors && (
								<>
									<td className={`${classes.table_td}`}>
										<div className={`${classes.table_div} ${classes.long_text} ${classes.center}`}>
											{item.area ? `${formatMilesDecimalNew(item.area)} Ha` : ""}
										</div>
									</td>
									<td className={`${classes.table_td}`}>
										<div className={`${classes.table_div} ${classes.long_text} ${classes.center}`}>{item.specie_name}</div>
									</td>
									<td className={`${classes.table_td}`}>
										<div className={`${classes.table_div} ${classes.long_text} ${classes.center}`}>{item.variety_name}</div>
									</td>
								</>
							)}
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center}`}>
									{filter.filter_type === "activos" && (
										<>
											{hasPermission("edit", permissions) && (
												<>{item.active && <ArchiveSvg className={classes.icon} onClick={() => handleArchive(item)} />}</>
											)}
											{hasPermission("edit", permissions) && (
												<PencilSvg
													className={classes.icon}
													onClick={() =>
														navigate(
															useSectors
																? "/configuracion/centro_costo/editar_grupo/" + item.slug
																: "/configuracion/centro_costo/editar/" + item.slug,
														)
													}
												/>
											)}
											{hasPermission("delete", permissions) && (
												<RemoveSvg className={classes.icon} onClick={() => handleDelete(item, useSectors ? "parent" : "child")} />
											)}
										</>
									)}
									{filter.filter_type === "historico" && !useSectors && (
										<>
											{hasPermission("edit", permissions) && (
												<>{!item.active && <ArchiveUpSvg className={classes.icon} onClick={() => handleArchive(item)} />}</>
											)}
										</>
									)}
								</div>
							</td>
							{!!useSectors && (
								<td className={`${classes.table_td}`}>
									<div className={`${classes.table_div} ${classes.last_div}`}>
										{item.show ? (
											<ArrowDownSvg className={classes.icon} onClick={() => toggleShowDetail(item.id)} />
										) : (
											<ArrowUpSvg className={classes.icon} onClick={() => toggleShowDetail(item.id)} />
										)}
									</div>
								</td>
							)}
						</tr>,
						<BusinessCenterTableDetail
							key={`detail_${i}`}
							filter={filter}
							item={item}
							handleDelete={handleDelete}
							permissions={permissions}
							handleArchive={handleArchive}
						/>,
					];
				})}
		</tbody>
	);
};

export default BusinessCenterTableBody;
